import React from "react";

const blogs = [
  {
    id: 1,
    title: "Why Every Business Needs a Modern Website in 2026",
    category: "Web Development",
    date: "January 12, 2026",
    image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085",
    desc: "A modern website is no longer optional. Learn how performance, UX, and SEO impact your brand credibility and customer trust.",
  },
  {
    id: 2,
    title: "Mobile App vs Website: Which One Should You Build First?",
    category: "Mobile Apps",
    date: "January 25, 2025",
    image: "https://images.unsplash.com/photo-1551650975-87deedd944c3",
    desc: "Choosing between a mobile app and a website can be confusing. We break down the pros, costs, and scalability factors.",
  },
  {
    id: 3,
    title: "The Power of UI/UX in Increasing Conversion Rates",
    category: "UI/UX Design",
    date: "February 5, 2025",
    image: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0",
    desc: "Great design is not just about looks. Discover how strategic UI/UX decisions directly impact engagement and revenue.",
  },
  {
    id: 4,
    title: "How AI is Transforming Modern Businesses",
    category: "Artificial Intelligence",
    date: "February 18, 2025",
    image: "https://images.unsplash.com/photo-1507149833265-60c372daea22",
    desc: "From automation to predictive analytics, AI is redefining how companies operate and scale in the digital era.",
  },
];

const Blog = () => {
  return (
    <section className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 px-6 py-20">
      
      {/* Heading */}
      <div className="text-center mb-16 max-w-3xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-blue-600 mb-4">
          Our Blog
        </h2>
        <p className="text-gray-700 text-lg md:text-xl leading-relaxed">
          Insights, strategies, and expert knowledge to help your business
          thrive in the digital world.
        </p>
      </div>

      {/* Blog Grid */}
      <div className="max-w-6xl mx-auto grid gap-10 sm:grid-cols-2 lg:grid-cols-2">
        {blogs.map((blog) => (
          <div
            key={blog.id}
            className="bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group flex flex-col"
          >
            {/* Image */}
            <div className="overflow-hidden">
              <img
                src={blog.image}
                alt={blog.title}
                className="w-full h-56 object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>

            {/* Content */}
            <div className="p-8 flex flex-col justify-between flex-grow">
              <div>
                <span className="text-sm text-blue-600 font-semibold">
                  {blog.category}
                </span>
                <h3 className="text-2xl font-bold text-gray-900 mt-2 mb-3">
                  {blog.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  {blog.desc}
                </p>
              </div>

              <div className="flex items-center justify-between mt-4">
                <span className="text-gray-400 text-sm">
                  {blog.date}
                </span>
                <button className="text-blue-600 font-semibold hover:underline">
                  Read More →
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* CTA Section */}
      <div className="mt-20 text-center">
        <p className="text-gray-700 text-lg md:text-xl mb-6">
          Want to stay updated with the latest tech trends?
        </p>
        <a
          href="/contact"
          className="inline-block bg-blue-600 text-white px-8 py-3 rounded-full font-semibold shadow-md hover:bg-blue-700 transition-colors duration-300"
        >
          Work With Us
        </a>
      </div>
    </section>
  );
};

export default Blog;